import { SelectOption } from 'shared/types';

export function checkIsOptionExists(
  value: string,
  options: SelectOption[]
): boolean {
  return options.some((option) => option.value === value);
}
